export function useScrollToRow() {
  return (rowId: string) => {
    setTimeout(() => {
      // AG Grid stamps each row with its `getRowId` value.
      const row = document.querySelector(`.ag-row[row-id="${rowId}"]`)
      row?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 300)
  }
}
